export default __webpack_public_path__ + "static/media/client-couple.999bf8eb.png";